// CRC32 (IEEE, как в zip): таблица считается один раз и переиспользуется

let table: Uint32Array | null = null

export function crc32Table(): Uint32Array {
  if (table === null) {
    table = new Uint32Array(256)
    for (let n = 0; n < 256; n++) {
      let c = n
      for (let k = 0; k < 8; k++) {
        c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1
      }
      table[n] = c >>> 0
    }
  }
  return table
}

export function crc32(bytes: Uint8Array): number {
  const t = crc32Table()
  let crc = 0xFFFFFFFF
  for (let i = 0; i < bytes.length; i++) {
    crc = t[(crc ^ bytes[i]) & 0xFF] ^ (crc >>> 8)
  }
  return (crc ^ 0xFFFFFFFF) >>> 0
}
